import React from "react";

const Plus = () => {
  return (
    <path d="M17.3014354,14.6985646 L30.6985646,14.6985646 C31.4173275,14.6985646 32,15.2812371 32,16 C32,16.7187629 31.4173275,17.3014354 30.6985646,17.3014354 L17.3014354,17.3014354 L17.3014354,30.6985646 C17.3014354,31.4173275 16.7187629,32 16,32 C15.2812371,32 14.6985646,31.4173275 14.6985646,30.6985646 L14.6985646,17.3014354 L1.30143541,17.3014354 C0.582672479,17.3014354 0,16.7187629 0,16 C0,15.2812371 0.582672479,14.6985646 1.30143541,14.6985646 L14.6985646,14.6985646 L14.6985646,1.30143541 C14.6985646,0.582672479 15.2812371,0 16,0 C16.7187629,0 17.3014354,0.582672479 17.3014354,1.30143541 L17.3014354,14.6985646 Z" />
  );
};

export default Plus;
